import React, { createContext, useState, useContext, useCallback } from 'react';

const NotificationContext = createContext();

export function useNotification() {
    return useContext(NotificationContext);
}

export function NotificationProvider({ children }) {
    const [notification, setNotification] = useState({
        message: '',
        type: '', // 'success', 'error', 'warning' o 'info'
        isVisible: false,
    });

    // Función para mostrar la notificación
    const showNotification = useCallback((message, type = 'success') => {
        setNotification({ message, type, isVisible: true });

        // Ocultar la notificación después de 3 segundos
        setTimeout(() => {
            setNotification({ message: '', type: '', isVisible: false });
        }, 3000);
    }, []);

    const value = {
        notification,
        showNotification,
    };

    return (
        <NotificationContext.Provider value={value}>
            {children}
        </NotificationContext.Provider>
    );
}